module.exports = __webpack_public_path__ + "static/img/h2-19.7fe6c18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/h2-19.png
// module id = oWS0
// module chunks = 1